<script lang="ts">
	import List from '$lib/elements/List.svelte';
	import { page } from '$app/stores';
	import { t } from 'svelte-i18n';
	import type { ComponentType } from '$lib/types/props';
	import { isSidebarOpen } from '@app/stores/sidebar';
	import { clickOutside } from '$lib/actions/clickOutside';
	import ButtonSVG from '$lib/elements/buttons/variants/ButtonSVG.svelte';
	import { viewport } from '$lib/stores';
	import { bannersHeight } from '@app/stores/banners';

	let scrollY;
	export let categoriesLinks: ComponentType[] = [];
	export let toggleSidebarRefs = [];
</script>

<svelte:window bind:scrollY />

<header
	use:clickOutside={{ action: () => ($isSidebarOpen = false), excludedRefs: toggleSidebarRefs }}
	class:open={$isSidebarOpen}
	class={'bg-white'}
	style="top:{$viewport.isDesktop ? `${$bannersHeight}px` : '0'}"
>
	<div class="container">
		<div class="lg:flex lg:items-center lg:gap-5 2xl:gap-7">
			<ButtonSVG
				props={{
					href: '/blog',
					classNames: `block text-primary flex-shrink-0 ${
						$page.data.user ? 'hidden lg:block' : ''
					}`,
					iconClassNames: '!w-[108px] !h-[38px] lg:!w-[137px] lg:!h-[49px]',
					name: 'logo_wiiiblog'
				}}
			/>

			<div class="whitespace-nowrap flex items-center pt-4 lg:pt-0 lg:flex-1 lg:justify-center">
				<List
					items={categoriesLinks}
					listStyle="none"
					itemOnClick={async () => ($isSidebarOpen = false)}
					itemsClassNames="pb-3 mb-3 mr-5 lg:pb-0 lg:mb-0 lg:inline-block"
					classNames=" mb-3 lg:mb-0 space-y-3 lg:space-y-0"
				/>
			</div>
			<div>
				<div class="inline"><a href="/">{$t('blog.navHomeLink')}</a></div>
			</div>
		</div>
	</div>
</header>

<style lang="postcss">
	header {
		@apply transform -translate-x-full transition-transform overflow-auto pb-7 fixed top-0 left-0 w-full h-full z-nav pt-4;
		@apply lg:w-full lg:translate-x-0 lg:pb-4 lg:h-auto lg:overflow-visible;
		&.open {
			transform: translateX(0);
		}
	}
</style>
